import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import 'next/stylesheets/components/fullscreen-overlay.scss';

Component('tr-fullscreen-overlay', {
  mixins: [eventListenerMixin],

  ready() {
    this.header = this.querySelector('.overlay-header');
    this.container = this.querySelector('.overlay-container');
    this.listenTo(this.container, 'scroll', this.handleContainerScroll.bind(this));
  },

  handleContainerScroll(event) {
    if (this.header) {
      this.header.classList.toggle('active', event.target.scrollTop > 0);
    }
  },

  beforeCache() {
    if (this.header) {
      this.header.classList.remove('active');
    }
  },

  disconnected() {
    this.stopListening();
  },
});
